export enum DocumentDetailsStatus {
    Viewable,
    RequiresAction,
    Completed,
    PendingPreparation,
}

export const DocumentDetailsStatusOptions = {
    [DocumentDetailsStatus.Viewable]: 'Viewable',
    [DocumentDetailsStatus.RequiresAction]: 'Requires Action',
    [DocumentDetailsStatus.Completed]: 'Completed',
    [DocumentDetailsStatus.PendingPreparation]: 'Pending Preparation',
};